import React from 'react';
import { FaFacebook, FaInstagram, FaYoutube } from 'react-icons/fa';
import { FaThreads } from 'react-icons/fa6';
import { Link, useLocation } from 'react-router-dom';

export default function FooterComponent() {
  const location = useLocation();

  const getLinkClass = (path) => {
    const isActive = location.pathname === path;
    return `${isActive ? 'transform scale-105 underline text-white' : 'hover:text-white'}`;
  };


  return (
    <footer className="bg-gray-900 text-gray-300 py-8">
      <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-6">

        {/* Links */}
        <div className="flex flex-wrap gap-4 text-sm">
          <Link to="/about" className={getLinkClass('/about')}>About Us</Link>
          <Link to="/contact" className={getLinkClass('/contact')}>Help Center</Link>
          <Link to="/privacy" className={getLinkClass('/privacy')}>Privacy</Link>
          <Link to="/terms" className={getLinkClass('/terms')}>Terms</Link>
        </div>

        {/* Social Icons */}
        <div className="flex gap-4">
          <a
            href="https://www.facebook.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white"
          >
            <FaFacebook size={20} />
          </a>

          <a
            href="https://www.instagram.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white"
          >
            <FaInstagram size={20} />
          </a>

          <a
            href="https://www.threads.net"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white"
          >
            <FaThreads size={20} />
          </a>

          <a
            href="https://www.youtube.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white"
          >
            <FaYoutube size={20} />
          </a>
        </div>

      </div>

      <div className="text-center text-xs text-gray-300 mt-6">
        © 2025 Accessify. All rights reserved.
      </div>
    </footer>
  );
}
